import eventBus, { EventTypes } from 'utils/helpers/eventBus';

function toggleMainSidebar(state: boolean): void {
  eventBus.emit(EventTypes.TOGGLE_MAIN_SIDEBAR, state);
}

export default toggleMainSidebar;
